<template lang="html">
    <div class="">
        <div class="singleColumnGrid bottom-padding-20">
            <span>
                <b>Loan Status: </b>
                <b class="green-color">Open </b>
            </span>
        </div>
        <div class="twoColumnGrid">
            <txt autofocus="autofocus" label='Employee Code / Name' type="text" v-model='formData.employee_code_name' name="employee_code_name"
                placeholder="" v-validate="'required'" :classname="errors.has('employee_code_name')" :errormsg="errors.first('employee_code_name')">
            </txt>
            <txt autofocus="autofocus" label='Loan Amount' type="text" v-model='formData.loan_amount' name="loan_amount" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_amount')" :errormsg="errors.first('loan_amount')">
            </txt>
            <txt autofocus="autofocus" label='Loan Name' type="text" v-model='formData.loan_amount' name="loan_name" placeholder="" v-validate="'required'"
                :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <div>
                <span class="feild-label">Disbursement Date</span>
                <date-picker class="margin-top-5" @datevalue="(val)=>formData.disbursement_date=val" :value="formData.disbursement_date"
                    v-model="formData.disbursement_date" :formatDate="'dd-MM-yyyy'" />
            </div>
            <div class="max-width-300">
                <span class="feild-label">Loan Description</span>
                <textarea class="form-control width-100 margin-top-5" v-model="formData.loanDescription">
                </textarea>
            </div>
            <div>
                <span class="feild-label">Re-Payment Start Date</span>
                <date-picker class="margin-top-5" @datevalue="(val)=>formData.disbursement_date=val" :value="formData.disbursement_date"
                    v-model="formData.disbursement_date" :formatDate="'dd-MM-yyyy'" />
            </div>
            <txt autofocus="autofocus" label='Opening Balance' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <div>
                <tl-select class="max-width-300" label="Interest Type" :value="formData.interestType" :options="interestTypesArray" @change="(val)=>changeInterestType(val)"
                />
            </div>
            <div>
                <tl-select class="max-width-300" label="Recovery Type" :value="formData.interestType" :options="interestTypesArray" @change="(val)=>changeInterestType(val)"
                />
            </div>
            <txt autofocus="autofocus" label='No of Installments' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <txt autofocus="autofocus" label='Rate of Interest' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <div>
                <tl-select class="max-width-300" label="Round of values" :value="formData.interestType" :options="interestTypesArray" @change="(val)=>changeInterestType(val)"
                />
            </div>
            <txt autofocus="autofocus" label='No of months paid' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
        </div>

        <div class="top-padding-20">
            <tl-checkbox class="padding-10" label="Calculation perquisite" @change="(val)=>calculatePerquisiteChange(val)">
            </tl-checkbox>
            <tl-checkbox class="padding-10" label="Is External Loan" @change="(val)=>isExternalLoanChange(val)">
            </tl-checkbox>
        </div>

        <div class="top-padding-20">
            <btn-grp>
                <btn text="Repayment Schedule" type="primary" @click="repaymentSchedule()" />
                <btn text="Reset" type="secondary" />
            </btn-grp>
        </div>

        <div class="padding-20">
            <data-table :columns="columnNames" :showeditCol="showeditCol" :tableData="paymentScheduleData" :checkbox="false" :showinrow="false"
            />
            <!-- <template v-slot:rowcontent="slotprops">
                            {{slotprops.value.column.key}}
                              <div class="" v-if="slotprops.value.column.key=='principalAmount'">
                                    <input/>
                              </div>
                              <div class="" v-if="slotprops.value.column.key=='interest'">
                                    <input/>
                              </div> 
                                <span>{{paymentScheduleData[slotprops.value.column.key]}}</span> 
                        </template> -->

        </div>



        <div class="twoColumnGrid top-padding-20">
            <txt autofocus="autofocus" label='Total Principal' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <txt autofocus="autofocus" label='Total Interest' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <txt autofocus="autofocus" label='Total Perquisite' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
            <txt autofocus="autofocus" label='Total Amount Due' type="text" v-model='formData.loan_amount' name="loan_name" placeholder=""
                v-validate="'required'" :classname="errors.has('loan_name')" :errormsg="errors.first('loan_name')">
            </txt>
        </div>

        <div class="btn-group">
            <bottom-action-container>
                <btn-grp slot="end">
                    <btn text="Back" type="secondary" @click="back" />
                    <btn text="Save" type="primary" class @click="save"></btn>
                </btn-grp>
            </bottom-action-container>
        </div>

    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";

    export default {
        name: "loanCalculation",
        computed: {
            ...mapState({}),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            })
        },
        data() {
            return {
                showeditCol: true,
                interestTypesArray: ["Interest 1", "Interest 2"],
                formData: {
                    employee_code_name: "",
                    loan_amount: "",
                    loan_name: "",
                    disbursement_date: "",
                    loanDescription: "",
                    interestType: ""
                },
                columnNames: [
                    {
                        label: "Sl.No",
                        key: "slno"
                    },
                    {
                        label: "Schedule Date",
                        key: "scheduleDate"
                    },
                    {
                        label: "Principal Amount",
                        key: "principalAmount"
                    },
                    {
                        label: "Interest",
                        key: "interest"
                    },
                    {
                        label: "Perquisite",
                        key: "perquisite"
                    }
                ],
                paymentScheduleData: [
                    {
                        id: 1,
                        slno: "1",
                        scheduleDate: "23 Jun 2019",
                        principalAmount: "",
                        interest: "",
                        perquisite: ""
                    },
                    {
                        id: 2,
                        slno: "2",
                        scheduleDate: "23 Jun 2019",
                        principalAmount: "",
                        interest: "",
                        perquisite: ""
                    },
                    {
                        id: 3,
                        slno: "3",
                        scheduleDate: "23 Jun 2019",
                        principalAmount: "",
                        interest: "",
                        perquisite: ""
                    },
                    {
                        id: 4,
                        slno: "4",
                        scheduleDate: "23 Jun 2019",
                        principalAmount: "",
                        interest: "",
                        perquisite: ""
                    }
                ]
            };
        },
        mounted() { },

        methods: {
            ...mapActions({}),

            changeInterestType() { },

            calculatePerquisiteChange() { },

            isExternalLoanChange() { },

            repaymentSchedule() { },

            back() { },

            save() { }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-top-5 {
        margin-top: 5px;
    }

    .top-padding-20 {
        padding: 20px 0px 0px;
    }

    .bottom-padding-20 {
        padding: 0px 0px 20px;
    }

    .padding-20 {
        padding: 20px 0px;
    }

    .padding-10 {
        padding: 10px 0px;
    }

    .max-width-300 {
        max-width: 300px;
    }

    .red-color {
        color: red;
    }

    .green-color {
        color: green;
    }

    .feild-label {
        font-family: Montserrat;
        font-size: 12px;
        font-weight: normal;
        color: #646464;
    }
</style>